exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host {\n  width: 330px;\n  margin-top: 54px;\n}\n\n.contributor {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.contributor img {\n  border-radius: 50%;\n}\n\nimg {\n  border: solid 2px rgba(255, 255, 255, 0.1);\n}\n\n.matsko img {\n  border: solid 3px rgba(255, 255, 255, 0.3);\n}\n\n.name {\n  padding-top:10px;\n  font-size: 20pt;\n  color: #fffef6;\n}\n\n.title {\n  font-size: 14pt;\n}\n\n.title a {\n  color: #aaaaaa;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/about-page/contributors/contributor.component.css
// module id = 208
// module chunks = 1